// Tono de retorno ("timbre") simulado para llamadas salientes de WhatsApp.
//
// WhatsApp no envia tono de retorno por el audio mientras el contacto timbra,
// asi que el asesor oiria silencio. Se genera aqui con Web Audio: 425 Hz,
// 1 s sonando y 4 s en silencio (cadencia usada en Colombia).

export const RINGBACK = {
  frequency: 425,
  onSeconds: 1,
  offSeconds: 4,
  volume: 0.15,
  rampSeconds: 0.02
};

const audioContextClass = () => (
  typeof window !== 'undefined' ? (window.AudioContext || window.webkitAudioContext) : null
);

export function createRingbackTone(options = {}) {
  const config = { ...RINGBACK, ...options };
  const AudioContextClass = 'AudioContext' in options ? options.AudioContext : audioContextClass();
  let context = null;
  let oscillator = null;
  let gain = null;
  let timer = null;
  let playing = false;

  // Crear el contexto durante el clic del asesor evita que el navegador lo
  // bloquee por reproduccion automatica cuando el tono empieza despues.
  const prepare = () => {
    if (context || !AudioContextClass) return;
    try {
      context = new AudioContextClass();
      if (context.state === 'suspended' && context.resume) context.resume().catch(() => {});
    } catch (error) {
      context = null;
    }
  };

  const scheduleCycle = () => {
    if (!playing || !gain) return;
    const now = context.currentTime;
    const end = now + config.onSeconds;
    gain.gain.cancelScheduledValues(now);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(config.volume, now + config.rampSeconds);
    gain.gain.setValueAtTime(config.volume, end - config.rampSeconds);
    gain.gain.linearRampToValueAtTime(0, end);
  };

  const start = () => {
    if (playing) return;
    prepare();
    if (!context) return;
    try {
      gain = context.createGain();
      gain.gain.value = 0;
      gain.connect(context.destination);
      oscillator = context.createOscillator();
      oscillator.type = 'sine';
      oscillator.frequency.value = config.frequency;
      oscillator.connect(gain);
      oscillator.start();
      playing = true;
      scheduleCycle();
      timer = setInterval(scheduleCycle, (config.onSeconds + config.offSeconds) * 1000);
    } catch (error) {
      stop();
    }
  };

  function stop() {
    playing = false;
    clearInterval(timer);
    timer = null;
    try { oscillator?.stop(); } catch (error) { /* ya detenido */ }
    try { oscillator?.disconnect(); } catch (error) { /* sin conexion */ }
    try { gain?.disconnect(); } catch (error) { /* sin conexion */ }
    oscillator = null;
    gain = null;
  }

  const close = () => {
    stop();
    if (context?.close) context.close().catch(() => {});
    context = null;
  };

  return { prepare, start, stop, close, isPlaying: () => playing };
}
